module.exports = __webpack_public_path__ + "static/media/klasa_2.212a7f81.svg";